export interface ITaskDataRowColIcon {
    name: string;
    tooltip: string;
}

export class TaskDataRowColIcon implements ITaskDataRowColIcon {
    name: string;
    tooltip: string;

    constructor();
    constructor(obj: ITaskDataRowColIcon);
    constructor(obj?: any) {
        this.name = obj && obj.name || "";
        this.tooltip = obj && obj.tooltip || "";
    }
}